module.exports = __webpack_public_path__ + "static/media/Apple iPhone 11 Green.b16462a7.png";